export default __webpack_public_path__ + "static/media/QR_Loading.1f062d30.gif";